import { cx } from '@orn/shared-web/utils/cx';
import * as React from 'react';

interface IWizardTitleProps {
  title: React.ReactNode;
  subtext?: React.ReactNode;
  className?: string;
}

const WizardTitle = ({ title, subtext, className }: IWizardTitleProps) => {
  return (
    <div className={cx('flex flex-col items-center justify-center gap-3 pb-4 pt-6', className)}>
      <div className="text-primary text-display-sm font-semibold">{title}</div>
      {subtext && (
        <div className={typeof subtext === 'string' ? 'text-secondary text-md text-center' : ''}>{subtext}</div>
      )}
    </div>
  );
};

export default WizardTitle;
